import React from 'react';
import { ITeacher } from 'models/Providers/Teacher';
import ShowcaseTeacherRow from 'parent-portal/home/components/ShowcaseTeacherRow';
import { Colors } from 'library';
import { Icon, PillButton } from 'library/ui';
import { ChevronRight } from '@mui/icons-material';

export default function PublicTeacherCard({ worker }: { worker: ITeacher }) {
    function openSignUp() {
        window.open('/signup', '_blank');
    }

    return (
        <ShowcaseTeacherRow
            worker={worker}
            rightAction={
                <PillButton onClick={openSignUp}>
                    Request {worker.name}
                    <Icon icon={ChevronRight} size="xs" bgColor={Colors.darkNavy} iconColor={Colors.white} />
                </PillButton>
            }
        />
    );
}
